import { AlertModal } from '@/components/modal/alert-modal';
import NotFoundPage from '@/components/not-found-page';
import { Spinner } from '@/components/ui/spinner';
import { i18nInitPromise } from '@/lib/i18n';
import { isIOS26OrHigher } from '@/lib/platform';
import type { RouterContext } from '@/router';
import { useStore } from '@/stores/store';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Toaster } from 'sonner';
import { useShallow } from 'zustand/react/shallow';

const RootLayout = () => {
  const [alert, hideAlert] = useStore(useShallow(s => [s.alert, s.hideAlert]));

  const { t } = useTranslation();

  return (
    <>
      <title>{t($ => $.appTitle)}</title>
      {/* O print:block é pela impressão: o Firefox não quebra container flex entre folhas. */}
      <div className="flex h-full min-h-screen flex-col print:block">
        <Outlet />
        <Toaster richColors position="bottom-right" />
        {/* iOS 26+: Adicionamos essas divs pois o safari determina a cor das barras
            do safe area(status bar e toolbar) a partir do background-color de elementos
            fixed/sticky. Esses divs ocultos controlam essa cor.
            Estilos em index.css (.safari-tint-*). */}
        {isIOS26OrHigher && (
          <>
            <div aria-hidden className="safari-tint-top" />
            <div aria-hidden className="safari-tint-bottom" />
          </>
        )}
        <AlertModal
          open={alert?.open ?? false}
          onClose={() => {
            hideAlert();
          }}
          message={alert?.message ?? ''}
          type={alert?.type ?? 'warning'}
        />
      </div>
    </>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: async () => {
    await i18nInitPromise;
  },
  component: RootLayout,
  notFoundComponent: () => <NotFoundPage />,
  pendingComponent: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <Spinner className="size-6" />
    </div>
  ),
});
